export const APP_PLATFORM_NAME = 'mTab Insight Cloud';
export const APP_IDENTIFIER = 'platform-learning-center';

export const { PUBLIC_URL = '' } = process.env;
